<div class="scorecard-description-page">
  <ng-container *ngIf="scorecardFamily">
    <fgbcl-scorecard-description-header
      [scorecardDescription]="scorecardDescription"
      (onPreviousClick)="onPreviousClick()"
      (onNextClick)="onNextClick()"
      #scorecardModalCarousel
      [isSponsorInBody]="isSponsorInBody"
    />
  </ng-container>
  <div class="container" [ngClass]="{ 'body-scorecard-completed': isCompleted }">
    <fgbcl-scorecard-description-body
      [scorecardDescription]="scorecardDescription"
      (onNextClick)="onNextClick($event)"
      (onPrevious)="onPreviousClick($event)"
      [isSponsorInBody]="isSponsorInBody"
    />
  </div>
</div>
